import script from "./CompanyCulture.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCulture.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCulture.vue?vue&type=style&index=0&id=04d7ed0b&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d7ed0b"]])

export default __exports__